<div class="relative" (click)="toggleMenu($event)">
  <div [class]="'flex items-center ' + toggleContainerClass()">
    <div
      class="flex gap-md items-center [&>lib-avatar:not(:first-child)]:-ms-sm [&>lib-avatar:not(:first-child)]:border-2 [&>lib-avatar:not(:first-child)]:border-white [&>lib-avatar:not(:first-child)]:rounded-full">
      <!-- single avatar + tooltip -->
      @if (croppedArray().length === 1 && showIndividualAvatar()) {
        @if (!showAssigneeName()) {
          <span
            libTooltip
            [toolTipTemplate]="toolTipTemplate"
            placement="top"
            [hasCloseIcon]="false"
            toolTipAction="mouseenter"
            [toolTipClass]="
              'bg-white p-md rounded-lg shadow-lg !w-auto tooltip-arrow tooltip-arrow-top translate-x-[30%] rtl:translate-x-0' +
              ' ' +
              toolTipClass()
            "
            class="flex gap-sm items-center cursor-pointer">
            @if (
              showVariableIcon() &&
              (croppedArray()[0].assignable_type === 'variable' ||
                assigneeType()[0] === 'variable')
            ) {
              <lib-variable-icon [iconClass]="'size-6'" />
            } @else {
              <lib-avatar
                [size]="''"
                [fullName]="
                  croppedArray()[0].name ?? croppedArray()[0].label ?? ''
                "
                [img]="croppedArray()[0].image?.url ?? ''"
                [imgDimensions]="{
                  width: imgDimensions().width,
                  height: imgDimensions().height,
                }"
                [unit]="'rem'"
                [placeholderTextClass]="'text-primary-500 font-medium text-xs'"
                borderRadius="rounded-full" />
            }

            <ng-template #toolTipTemplate>
              <div class="text-xs font-medium text-neutral-900">
                {{ croppedArray()[0].name ?? croppedArray()[0].label ?? '' }}
              </div>

              @if (croppedArray()[0].assignable_type || assigneeType()[0]) {
                <div class="flex items-center gap-x-sm">
                  <div class="text-xs text-neutral-500 font-normal">
                    {{
                      'workflow_step_info_form_{' +
                        (croppedArray()[0].assignable_type ||
                          assigneeType()[0]) +
                        '}_label' | transloco
                    }}
                  </div>

                  @if (croppedArray()[0].option) {
                    <span class="text-xs text-neutral-300"> | </span>

                    <span class="text-xs text-neutral-500 font-normal">
                      {{ croppedArray()[0].option }}
                    </span>
                  }
                </div>
              }
            </ng-template>
          </span>
        } @else {
          <lib-avatar
            [size]="''"
            [fullName]="croppedArray()[0].name ?? croppedArray()[0].label ?? ''"
            [img]="croppedArray()[0].image?.url ?? ''"
            [imgDimensions]="{
              width: imgDimensions().width,
              height: imgDimensions().height,
            }"
            [unit]="'rem'"
            [placeholderTextClass]="'text-primary-500 font-medium text-xs'"
            borderRadius="rounded-full" />

          <div class="flex min-w-0 flex-col justify-center">
            <div
              class="text-neutral-900 font-medium text-xs/3.5 line-clamp-1">
              {{ croppedArray()[0].name ?? croppedArray()[0].label ?? '' }}
            </div>

            @if (croppedArray()[0].assignable_type || assigneeType()[0]) {
              <div class="flex items-center">
                <div
                  data-assignee-type
                  class="text-xs2/3.5 text-neutral-500 font-normal">
                  {{
                    'workflow_step_info_form_{' +
                      (croppedArray()[0].assignable_type || assigneeType()[0]) +
                      '}_label' | transloco
                  }}
                </div>

                @if (croppedArray()[0].option) {
                  <span class="text-xs2/3.5 text-neutral-300"> | </span>

                  <span class="text-xs2/3.5 text-neutral-500 font-normal">
                    {{ croppedArray()[0].option }}
                  </span>
                }
              </div>
            } @else if (croppedArray()[0].job_title) {
              <div
                libTrimTooltip
                placement="top"
                [trimLength]="trimLength()"
                [toolTipClass]="'bg-white p-md rounded-lg shadow-lg !w-auto tooltip-arrow tooltip-arrow-top !top-8xl'"
                position="absolute"
                [fullText]="croppedArray()[0].job_title ?? ''"
                class="text-neutral-500 font-normal text-xs2/3.5 truncate label-width">
                {{ croppedArray()[0].job_title }}
              </div>
            }
          </div>
        }
      }

      <!-- avatar list -->
      @if (croppedArray().length > 1 || !showIndividualAvatar()) {
        <button
          type="button"
          name="showUsersMenu"
          class="bg-transparent flex items-center [&>lib-avatar:not(:first-child)]:-ms-sm [&>lib-avatar:not(:first-child)]:border-2 [&>lib-avatar:not(:first-child)]:border-white [&>lib-avatar:not(:first-child)]:rounded-full"
          [class.cursor-pointer]="!enableDropdownIcon()"
          [class.!cursor-default]="enableDropdownIcon()">
          @for (user of croppedArray(); track $index) {
            @if (
              showVariableIcon() &&
              (user.assignable_type === 'variable' ||
                assigneeType()[$index] === 'variable')
            ) {
              <lib-variable-icon [iconClass]="'size-6'" />
            } @else {
              <lib-avatar
                [size]="''"
                [fullName]="user.name ?? user.label ?? ''"
                [img]="user.image?.url ?? ''"
                [imgDimensions]="{
                  width: imgDimensions().width,
                  height: imgDimensions().height,
                }"
                [unit]="'rem'"
                [placeholderTextClass]="'text-primary-500 font-medium text-xs'"
                borderRadius="rounded-full" />
            }
          }

          <lib-avatar
            [label]="'+' + (userCount() - croppedNumber())"
            [size]="''"
            [imgDimensions]="{
              width: imgDimensions().width,
              height: imgDimensions().height,
            }"
            [unit]="'rem'"
            [hidden]="userCount() < croppedNumber() + 1"
            [placeholderTextClass]="'text-primary-500 font-medium text-xs'"
            borderRadius="rounded-full" />
        </button>
      }
    </div>

    <!-- dropdown icon -->
    @if (
      (croppedArray().length > 1 || !showIndividualAvatar()) &&
      enableDropdownIcon()
    ) {
      <div class="flex items-center gap-sm cursor-pointer relative ms-lg">
        <button
          name="showUsersMenu"
          type="button"
          class="bg-transparent cursor-pointer flex">
          <lib-chevron-down-icon
            [iconClass]="
              'size-5 text-neutral-500 ' + (isMenuOpen() ? 'rotate-180' : '')
            " />
        </button>
      </div>
    }
  </div>

  @if (allowCustomToggleButton()) {
    <button type="button" name="showUsersMenu" class="w-full">
      <ng-content select="[custom-list-toggle-button]" />
    </button>
  }
</div>

<div
  #menuOverlayContent
  class="overflow-hidden z-[2] hidden w-[16.25rem] max-h-[20.75rem] flex flex-col bg-white shadow-xl rounded-lg items-center gap-sm py-2xl px-lg"
  [style.height.px]="menuHeight() ? menuHeight() : 'auto'">
  <div class="text-start text-xs font-semibold text-neutral-900 w-full">
    {{ searchLabel() }}
  </div>

  <div class="relative mb-sm w-full">
    <input
      #searchInput
      class="outline-0 border border-neutral-300 placeholder:text-neutral-500 text-sm sticky top-0 p-md w-full rounded-md"
      type="text"
      [placeholder]="searchPlaceholder()"
      [class.cursor-not-allowed]="!userDropdownList().length && !searchTerm()"
      [disabled]="!userDropdownList().length && !searchTerm()"
      (input)="onSearchTermChange($event.target)" />

    <!-- search icon -->
    <lib-search-icon
      [iconClass]="'size-5 text-neutral-500 absolute end-md inset-y-[27.5%]'" />
  </div>

  <ng-content select="[additional-menu-overlay-actions]" />

  <div class="flex items-center gap-sm w-full">
    <div class="font-medium text-neutral-700 text-xs">
      {{ headerListLabel() }}
    </div>

    <lib-badge
      [label]="totalDropdownCount().toString()"
      [badgeClass]="'px-sm border-none text-xs font-medium text-primary-500 bg-primary-50'" />
  </div>

  <div
    class="overflow-x-hidden overflow-y-auto pe-sm w-full"
    (scroll)="onScroll($event)">
    @if (!userDropdownList().length && isDropdownLoading()) {
      <lib-loader [size]="'sm'" />
    } @else if (userDropdownList().length) {
      @for (
        user of userDropdownList();
        track user.id ?? user.value;
        let index = $index
      ) {
        <div
          class="border-b border-neutral-200 w-full flex items-center gap-md py-md">
          @if (
            showVariableIcon() &&
            (user.assignable_type === 'variable' ||
              assigneeType()[index] === 'variable')
          ) {
            <lib-variable-icon [iconClass]="'size-6'" />
          } @else {
            <lib-avatar
              [fullName]="user.name ?? user.label ?? ''"
              [img]="user.image?.url ?? ''"
              [size]="''"
              [imgDimensions]="{
                width: imgDimensions().width,
                height: imgDimensions().height,
              }"
              [unit]="'rem'"
              [placeholderTextClass]="'text-primary-500 font-medium text-xs'"
              borderRadius="rounded-full" />
          }

          <div>
            <div
              libTrimTooltip
              placement="top"
              [trimLength]="trimLength()"
              [toolTipClass]="'bg-white p-md rounded-lg shadow-lg !w-auto tooltip-arrow tooltip-arrow-top !top-8xl'"
              position="absolute"
              [fullText]="user.name ?? user.label ?? ''"
              class="text-neutral-900 font-medium text-xs truncate label-width">
              {{ user.name ?? user.label ?? '' }}
            </div>

            @if (user.assignable_type || assigneeType()[index]) {
              <div class="flex items-center gap-x-sm">
                <div class="text-xs text-neutral-500 font-normal">
                  {{
                    'workflow_step_info_form_{' +
                      (user.assignable_type || assigneeType()[index]) +
                      '}_label' | transloco
                  }}
                </div>

                @if (user.option) {
                  <span class="text-xs text-neutral-300"> | </span>

                  <span class="text-xs text-neutral-500 font-normal">
                    {{ user.option }}
                  </span>
                }
              </div>
            } @else if (user.job_title) {
              <div
                libTrimTooltip
                placement="top"
                [trimLength]="trimLength()"
                [toolTipClass]="'bg-white p-md rounded-lg shadow-lg !w-auto tooltip-arrow tooltip-arrow-top !top-8xl'"
                position="absolute"
                [fullText]="user.job_title ?? ''"
                class="text-neutral-500 font-normal text-xs truncate label-width">
                {{ user.job_title }}
              </div>
            }
          </div>

          @if (enableDeleteItem()) {
            <button
              type="button"
              class="bg-transparent ms-auto"
              [disabled]="disableDeleteItem()"
              (click)="
                !disableDeleteItem()
                  ? deleteItem.emit(user.id ?? user.value)
                  : null
              ">
              <lib-remove-item-icon
                [iconClass]="'size-5 text-destructive-500'" />
            </button>
          } @else if (enableAddItem()) {
            <button
              type="button"
              class="bg-transparent ms-auto"
              [disabled]="disableAddItem()"
              (click)="!disableAddItem() ? addItem.emit(user) : null">
              <lib-add-icon [iconClass]="'size-5 text-primary-500'" />
            </button>
          }
        </div>
      }

      @if (isDropdownLoading()) {
        <div class="flex justify-center w-full">
          <lib-loader [size]="'sm'" />
        </div>
      }
    } @else {
      <div
        class="py-2xl px-lg flex flex-col items-center justify-center gap-lg">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="57"
          height="56"
          viewBox="0 0 57 56"
          fill="none">
          <path
            opacity="0.4"
            d="M27.3327 48.9993C39.575 48.9993 49.4993 39.075 49.4993 26.8327C49.4993 14.5904 39.575 4.66602 27.3327 4.66602C15.0904 4.66602 5.16602 14.5904 5.16602 26.8327C5.16602 39.075 15.0904 48.9993 27.3327 48.9993Z"
            fill="#D1D5DB" />
          <path
            d="M50.2 51.3333C49.78 51.3333 49.36 51.17 49.0566 50.8666L44.7166 46.5266C44.0866 45.8966 44.0866 44.87 44.7166 44.2166C45.3466 43.5866 46.3733 43.5866 47.0266 44.2166L51.3666 48.5566C51.9966 49.1866 51.9966 50.2133 51.3666 50.8666C51.04 51.17 50.62 51.3333 50.2 51.3333Z"
            fill="var(--color-primary-500)" />
          <path
            d="M33.1667 29.0508H21.5C20.5433 29.0508 19.75 28.2574 19.75 27.3008C19.75 26.3441 20.5433 25.5508 21.5 25.5508H33.1667C34.1233 25.5508 34.9167 26.3441 34.9167 27.3008C34.9167 28.2574 34.1233 29.0508 33.1667 29.0508Z"
            fill="var(--color-primary-500)" />
        </svg>
        {{ noSearchResultLabel() }}
      </div>
    }
  </div>
</div>
